@let section = this.sectionService.section();
@if (section) {
  <div
    class="flex !w-full flex-col rounded-2xl border border-gray-200 bg-white"
    cdkDrag
    [cdkDragData]="sectionId()"
    [cdkDragPreviewContainer]="ref()"
  >
    <div
      [pTooltip]="section.customization.description"
      class="relative flex flex-row items-center justify-between gap-2 px-5 pb-4 pt-3"
    >
      <div class="flex flex-col gap-1">
        @if (!inlineTitleEditor()) {
          <div class="text-lg font-bold" (click)="inlineTitleEditor.set(true)">
            {{ section.customization.title }}
          </div>
        } @else {
          <div
            class="rounded-md border-[1px] border-slate-300 px-2 text-lg font-bold"
          >
            <input
              #titleInput
              type="text"
              placeholder="titolo"
              [formControl]="title"
              (blur)="closeInlineTitleEditor()"
            />
          </div>
        }
        @if (!inlineSubTitleEditor()) {
          <div (click)="inlineSubTitleEditor.set(true)">
            {{ section.customization.subTitle }}
          </div>
        } @else {
          <div class="rounded-md border-[1px] border-slate-300 px-2">
            <input
              #subTitleInput
              type="text"
              placeholder="sottotitolo"
              [formControl]="subTitle"
              (blur)="closeInlineSubTitleEditor()"
            />
          </div>
        }
      </div>
      <div class="flex flex-row items-center gap-1">
        @if (sectionService.subsectionPointsOverMaxAllowed()) {
          <mat-icon
            class="icon-size-5 text-amber-700"
            svgIcon="heroicons_solid:exclamation-triangle"
            pTooltip="La somma dei punteggi delle sottosezioni supera il punteggio della sezione"
          ></mat-icon>
        }
        @if (!inlinePointsEditor()) {
          <div
            class="text-end text-lg font-bold"
            (click)="inlinePointsEditor.set(true)"
          >
            {{ section.customization.points }} pt
          </div>
        } @else {
          <div
            class="self-end rounded-md border-[1px] border-slate-300 px-2 text-lg font-bold"
          >
            <input
              #pointsInput
              class="w-10"
              type="number"
              [formControl]="points"
              (blur)="closeInlinePointsEditor()"
            />
          </div>
        }
      </div>
      <div
        [cdkMenuTriggerFor]="menu"
        [cdkMenuPosition]="positions"
        cdkDragHandle
        class="absolute right-0 top-0.5 -mr-8 flex h-full flex-col overflow-hidden rounded-md bg-slate-200 hover:bg-slate-300"
      >
        <mat-icon color="black" class="my-auto flex">drag_indicator</mat-icon>

        <div
          *cdkDragPreview
          class="flex cursor-pointer flex-row rounded-2xl bg-white py-3 pl-2 pr-3 shadow-md"
        >
          <div class="w-max justify-center self-center px-2">
            {{ sectionId() }}
          </div>
        </div>

        <div *cdkDragPlaceholder class="placeholder p-3">
          <div
            class="min-h-10 rounded-md bg-gray-500 bg-opacity-15 outline-dotted outline-4 outline-offset-2 outline-gray-300"
          ></div>
        </div>
      </div>
    </div>
    <div class="mx-4 flex flex-1 border-t-2 border-[#CAC4D0] opacity-50"></div>
    <div
      cdkDropList
      [id]="sectionId()"
      [cdkDropListData]="section.children"
      (cdkDropListDropped)="drop($event)"
      [cdkDropListConnectedTo]="dragdropService.sectionList()"
      cdkDropListOrientation="vertical"
      class="columnContainer grid-col flex flex-col"
      data-text="Nessuna colonna inserita"
      #subsectionContainer
    >
      @for (subsection of section.children; track subsection; let i = $index) {
        <lib-edit-sub-section
          class="min-w-0 flex-1 border-l-0"
          [subSectionId]="subsection"
          [ref]="subsectionContainer"
        />
      }
    </div>
  </div>

  <ng-template #menu>
    <div class="mr-2 flex flex-row rounded-md" cdkMenu>
      <button
        mat-icon-button
        cdkMenuItem
        pTooltip="Aggiungi Sottosezione"
        tooltipPosition="bottom"
        (click)="sectionService.addSubSection()"
      >
        <mat-icon svgIcon="heroicons_outline:plus"></mat-icon>
      </button>
      <button
        mat-icon-button
        cdkMenuItem
        pTooltip="Personalizza Sezione"
        tooltipPosition="bottom"
        (click)="sectionService.sectionCustomizationVisible.set(true)"
      >
        <mat-icon svgIcon="heroicons_outline:cog-8-tooth"></mat-icon>
      </button>
      <button
        mat-icon-button
        cdkMenuItem
        pTooltip="Rimuovi Sezione"
        tooltipPosition="bottom"
        (click)="sectionService.removeSection()"
      >
        <mat-icon svgIcon="heroicons_outline:trash"></mat-icon>
      </button>
      <button
        cdkMenuItem
        pTooltip="Copia Sezione"
        tooltipPosition="bottom"
        mat-icon-button
        (click)="sectionService.copySection()"
      >
        <mat-icon svgIcon="heroicons_outline:clipboard"></mat-icon>
      </button>
      @if (sectionService.sectionPasteEnabled()) {
        <button
          (click)="sectionService.pasteSection()"
          cdkMenuItem
          pTooltip="Incolla Sezione"
          mat-icon-button
        >
          <mat-icon svgIcon="heroicons_outline:clipboard-document"></mat-icon>
        </button>
      }
      @if (sectionService.subsectionPasteEnabled()) {
        <button
          (click)="sectionService.pasteSubSection()"
          cdkMenuItem
          pTooltip="Incolla Sottosezione"
          mat-icon-button
        >
          <mat-icon svgIcon="heroicons_outline:clipboard-document"></mat-icon>
        </button>
      }
    </div>
  </ng-template>

  <p-dialog
    header="Personalizza sezione"
    [appendTo]="'body'"
    [modal]="true"
    [closable]="false"
    [draggable]="false"
    [closeOnEscape]="true"
    [visible]="sectionService.sectionCustomizationVisible()"
    (visibleChange)="updateVisiblity($event)"
  >
    @if (sectionService.sectionCustomizationVisible()) {
      <lib-section-customization-panel />
    }
  </p-dialog>
}
